import secureStorage from '../utils/secureStorage'

const AUTH_ERROR_STATUSES = [401, 403, 419, 440]

export const redirectToLogin = (navigate) => {
  secureStorage.removeItem('logged_user')

  const currentPath = window.location.pathname + window.location.search
  if (currentPath !== '/login') {
    sessionStorage.setItem('login_redirect', currentPath)
  }

  if (typeof navigate === 'function') {
    navigate('/login', { replace: true })
    return
  }

  if (window.location.pathname !== '/login') {
    window.location.href = '/login'
  }
}

export const handleAuthError = (error, navigate) => {
  const status = error?.response?.status

  if (!AUTH_ERROR_STATUSES.includes(status)) {
    return false
  }

  redirectToLogin(navigate)
  return true
}
